import React, {useContext, useState} from 'react';
import {RadioButton} from '../../components/buttons/radio-button/radio-button';
import {THEMES} from '../../core/constants';
import {ThemeContext} from '../../services/theme/themeContext';
import {analyticsEvent} from '../../utils/analytics';
import {themeOptions} from '../../utils/utils';

export const SettingsStyleComponent = () => {
    const ThemeService = useContext(ThemeContext);

    const detectInitialTheme = (): string => {
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme) {
            return savedTheme;
        }
        const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
        return systemPrefersDark ? themeOptions[1] : themeOptions[0];
    };

    const [checked, setChecked] = useState<string>(detectInitialTheme());

    const changeTheme = (value: any, e: any) => {
        analyticsEvent('Configuració', 'configuration_themeselector_click');
        const newTheme = value.value === themeOptions[0] ? themeOptions[0] : themeOptions[1];
        ThemeService.setTheme(newTheme);
        setChecked(newTheme);
        localStorage.setItem('theme', newTheme);
        window.location.reload();
    };

    return (
        <div>
            {THEMES.map((value: any, index: number) => {
                return (
                    <div className="search-radio-button-group" key={index}>
                        <RadioButton
                            changeFunc={changeTheme}
                            checkedOption={value.value}
                            checked={checked}
                            label={value.title}
                            value={value}
                        />
                    </div>
                );
            })}
        </div>
    );
};
